export default __webpack_public_path__ + "static/media/banner2.0d063aad.jpg";